import { GemaraLocationInterface } from '../classes/gemara-location';
import { MishnaLocationInterface } from '../classes/mishna-location';






export enum SourceType {
  Gemara = 'gemara',
  Mishna = 'mishna',
  Literal = 'literal',
  Unknown = 'unknown',
}



export const defaultSourceModel:SourceModel = {
  masechta: '',

  sourceType: SourceType.Unknown,
  isRange: false,
  sourceStyle: 0,
  isLiteral: false,
  isUnknown: false,
  literalText: '',

  gemaraStartLocation: null,
  gemaraEndLocation: null,

  mishnaStartLocation: null,
  mishnaEndLocation: null,

  renderTextShort: '',
  renderTextFull: '',
};



export interface SourceModel {
  masechta:string,

  sourceType:SourceType,
  isRange:boolean,
  sourceStyle:number,
  isLiteral:boolean,
  isUnknown:boolean,

  literalText:string,

  gemaraStartLocation:GemaraLocationInterface,
  gemaraEndLocation:GemaraLocationInterface,

  mishnaStartLocation:MishnaLocationInterface,
  mishnaEndLocation:MishnaLocationInterface,

  renderTextShort:string,
  renderTextFull:string,
}




// WEBPACK FOOTER //
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/admin-area/models/source.model.ts